import { getCookieWithoutJSON, setCookieWithoutJSON } from '@dataplace.ai/functions/utils'
import dayjs from 'dayjs'
import i18next from 'i18next'
import React, { createContext, useState } from 'react'

export interface ILanguageContext {
  language: string
  setLanguage: (language: string) => void
}

export const LanguageContext = createContext<ILanguageContext | null>(null)

function LanguageContextProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const [language, _setLanguage] = useState(getCookieWithoutJSON('language') || 'pl')

  const setLanguage = (newLanguage: string) => {
    _setLanguage(newLanguage)
    setCookieWithoutJSON('language', newLanguage)
    i18next.changeLanguage(newLanguage)
    dayjs.locale(newLanguage)
  }

  return (
    <LanguageContext.Provider
      value={{
        language,
        setLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  )
}

export default LanguageContextProvider
